// Shared grid templates — header + rows MUST match for visual alignment.
// `gap-8` is 32px between columns per the design. When voting is enabled, the
// 7th column reserves the vote control's 76px minimum. When it is disabled,
// the six content columns fill that space instead of leaving a blank gutter.
//
// This lives in a NEUTRAL (non-`'use client'`) module on purpose: the desktop
// row skeleton and the route-level `loading.tsx` are SERVER-rendered, so they
// import this constant directly. A value exported from a `'use client'` module
// is replaced by a client-reference proxy when imported into a Server Component
// — stringifying that proxy into a className yields garbage and the grid
// collapses to a single column. Keeping the string here makes it a plain value
// usable from both server and client.
const ROW_GRID_WITH_VOTES_CLASS =
  'grid-cols-[minmax(0,2.5fr)_minmax(0,1.5fr)_minmax(0,0.75fr)_minmax(0,0.75fr)_minmax(0,1fr)_minmax(0,1.4fr)_minmax(4.75rem,max-content)] gap-8 items-center' as const;

const ROW_GRID_WITHOUT_VOTES_CLASS =
  'grid-cols-[minmax(0,2.5fr)_minmax(0,1.5fr)_minmax(0,0.75fr)_minmax(0,0.75fr)_minmax(0,1fr)_minmax(0,1.4fr)] gap-8 items-center' as const;

export function getProposalFeedGridClass(proposalVotingEnabled: boolean): string {
  return proposalVotingEnabled ? ROW_GRID_WITH_VOTES_CLASS : ROW_GRID_WITHOUT_VOTES_CLASS;
}
